export default __webpack_public_path__ + "assets/images/190d14aae42b484128bcc21f649319ff.png";